import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
    APPLICATION_DETAIL_LOADDATA,
    APPLICATION_DETAIL_SUCCESS,
    APPLICATION_LIST_SUCCESS
} from "../constants/ApplicationdetailConst";
import {success} from "../actions/ApplicationdetailActions";
import ApplicationService from "../../services/ApplicationService";

export function* loaddata() {
    yield takeEvery(APPLICATION_DETAIL_LOADDATA, function* (payload) {
        try {
            const res = yield call(ApplicationService.getdetail,payload.id);
            console.log('->>>>>>>>>>');
            yield put(success(res.data.data));
            console.log(res);
        } catch (err) {
            console.log('->>>>>>>>>> error');
            console.log(err);
        }
    });
}


export default function* rootSaga() {
    yield all([
        fork(loaddata)
    ]);
}
